import eventService from "..";
import { cache } from "swr";
import { AppEvent } from "../constants";
import attributeService from "services/attributeService";
import Cookies from "js-cookie";
import metricService from "services/metricService";
import RestAPIClient from "services/RestAPIClient";

eventService.addListener(AppEvent.LOGOUT, () => {
  metricService.clearCache();
  attributeService.clearCache();
  cache.clear();
  Cookies.remove("customer_id");
  RestAPIClient.token = undefined;
});
